// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2610":"6c74f00f","3198":"f32f0d70","3525":"f2a5d995","3877":"844d1f38","9372":"0aa7704b"}[chunkId] + ".chunk.css";
};